import { Mail, Phone, MapPin, MessageCircle } from "lucide-react";
import { COMPANY } from "@/data/products";

const LINKS = [
  { label: "Home", href: "#home" },
  { label: "About Us", href: "#about" },
  { label: "Products", href: "#products" },
  { label: "Supplier Partnerships", href: "#suppliers" },
  { label: "Contact", href: "#contact" },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#071630] text-[#c7d2e4]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <div className="inline-block bg-white rounded-xl px-4 py-3 mb-6">
            <img src="/assets/logo.png" alt="VIGO SOLUTIONS SDN. BHD. logo" className="h-12 w-auto object-contain" />
          </div>
          <p className="font-bold text-white mb-1" data-testid="footer-legal-name">{COMPANY.legalName}</p>
          <p className="text-sm text-[#8a97ad]" data-testid="footer-ssm">SSM Registration No. {COMPANY.ssm}</p>
        </div>

        <div>
          <h3 className="text-white font-bold text-sm tracking-widest uppercase mb-5">Contact</h3>
          <ul className="space-y-3.5 text-sm">
            <li>
              <a href={`mailto:${COMPANY.email}`} className="inline-flex items-center gap-2.5 hover:text-[#5ec4bc] transition-colors" data-testid="footer-email">
                <Mail className="w-4 h-4 text-[#5ec4bc]" /> {COMPANY.email}
              </a>
            </li>
            <li>
              <a href={`tel:${COMPANY.phoneTel}`} className="inline-flex items-center gap-2.5 hover:text-[#5ec4bc] transition-colors" data-testid="footer-phone">
                <Phone className="w-4 h-4 text-[#5ec4bc]" /> {COMPANY.phoneDisplay}
              </a>
            </li>
            <li>
              <a
                href={`https://wa.me/${COMPANY.whatsapp}`}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2.5 hover:text-[#5ec4bc] transition-colors"
                data-testid="footer-whatsapp"
              >
                <MessageCircle className="w-4 h-4 text-[#5ec4bc]" /> WhatsApp {COMPANY.phoneDisplay}
              </a>
            </li>
            <li className="flex gap-2.5" data-testid="footer-address">
              <MapPin className="w-4 h-4 text-[#5ec4bc] shrink-0 mt-0.5" />
              <span className="leading-relaxed">Business Address: {COMPANY.address}</span>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="text-white font-bold text-sm tracking-widest uppercase mb-5">Navigate</h3>
          <ul className="space-y-3.5 text-sm">
            {LINKS.map((l) => (
              <li key={l.href}>
                <a href={l.href} className="hover:text-[#5ec4bc] transition-colors" data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}>
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 text-center text-xs text-[#8a97ad]" data-testid="footer-copyright">
          © {year} {COMPANY.legalName} All rights reserved.
        </div>
      </div>
    </footer>
  );
}
